import { useQuery } from '@tanstack/react-query';
import { getTimeTillEndOfDayMs } from '@toggle/helpers';

import { fetchPublicLists } from '~/services/watchlist/watchlist';

export const QUERY_KEY_PUBLIC_LISTS = 'QUERY_KEY_PUBLIC_LISTS';

export const usePublicLists = () =>
  useQuery({
    queryKey: [QUERY_KEY_PUBLIC_LISTS],
    queryFn: fetchPublicLists,
    staleTime: getTimeTillEndOfDayMs(),
  });
